import { createSlice } from "@reduxjs/toolkit";
import { submitFlags } from "../../activityAsyncAction";
import logTypes from "../logTypes";

const initialState = {
  currentNoOfSnapshots: 0,
  takeSnapshotReg: 0, //regular periodic snapshot
  takeSnapshotAbs: 0, // face absence snapshot
  showCount: 0,
  faceAbsencePeriod: 0,
  numberOfFaceAbsence: 0,
  isAbsent: false,
  snapshotLog: {},
  numberOfSnapShots: 10,
};

export const snapshotSlice = createSlice({
  name: "snapshot",
  initialState,
  reducers: {
    takeshotRegAction: (state) => {
      const { takeSnapshotReg } = state;
      state.takeSnapshotReg = takeSnapshotReg + 1;
    },
    updateSnapshotCount: (state) => {
      const { currentNoOfSnapshots } = state;
      state.currentNoOfSnapshots = currentNoOfSnapshots + 1;
    },
    showSnaphotCount: (state) => {
      const { showCount } = state;
      state.showCount = showCount + 1;
    },
    setFaceAbsencePeriod: (state, action) => {
      state.faceAbsencePeriod = action.payload;
      console.log("this is");
    },
    updateFaceAbsencePeriod: (state) => {
      const { faceAbsencePeriod } = state;
      state.faceAbsencePeriod = faceAbsencePeriod + 1;
      if (state.faceAbsencePeriod === 6) {
        state.isAbsent = true;
      } else if (state.faceAbsencePeriod < 6) {
        state.isAbsent = false;
      }
    },
    addSnapshotLog: (state, action) => {
      state.snapshotLog[action.payload.id] = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(submitFlags.fulfilled, (state, action) => {
      const { id, logType } = action.payload;
      if (logType !== logTypes.SOUND_DETECTED && state.snapshotLog[id]) {
        state.snapshotLog[id].saved = true;
        state.snapshotLog[id].dataUrl = URL.revokeObjectURL(
          state.snapshotLog[id].dataUrl
        );
      }
    });
    // Add reducers for additional action types here, and handle loading state as needed
    // builder.addCase(fetchUserById.fulfilled, (state, action) => {
    //   // Add user to the state array
    //   state.entities.push(action.payload)
    // })
  },
});

// Action creators are generated for each case reducer function
export const {
  showSnaphotCount,
  updateFaceAbsencePeriod,
  takeshotRegAction,
  setFaceAbsencePeriod,
  updateSnapshotCount,
  addSnapshotLog,
} = snapshotSlice.actions;

export default snapshotSlice.reducer;
